<h4 *ngIf="insumo.id">Movimentações do Insumo <b>{{insumo.nome}}</b></h4>
<h4 *ngIf="produto.id">Movimentações do Produto <b>{{produto.nome}}</b></h4>

<kendo-grid
  class="historico-movimentacoes-grid"
  [loading]="carregando"
  [data]="gridData"
  [pageSize]="paginacao.size"
  [skip]="paginacao.skip"
  [pageable]="true"
  [resizable]="true"
  (pageChange)="mudouPaginacao($event)">
  <kendo-grid-messages
    pagerPage="Página"
    pagerOf="de"
    pagerItems="itens"
    noRecords="Nenhuma movimentação registrada"
    loading="Carregando"
    pagerItemsPerPage="itens por página">
  </kendo-grid-messages>

  <ng-template kendoGridToolbarTemplate>
    <div class="historico-filtros">
      <div class="historico-filtro-campo">
        <label>De</label>
        <kendo-datepicker
          [(ngModel)]="filtro.inicio"
          [format]="'dd/MM/yyyy'"
          class="form-control">
        </kendo-datepicker>
      </div>

      <div class="historico-filtro-campo">
        <label>Até</label>
        <kendo-datepicker
          [(ngModel)]="filtro.fim"
          [format]="'dd/MM/yyyy'"
          class="form-control">
        </kendo-datepicker>
      </div>

      <button type="button" class="btn btn-blue" (click)="apliqueFiltro()">
        Aplicar período
      </button>
    </div>
  </ng-template>

  <kendo-grid-column title="Movimentação" [width]="150">
    <ng-template kendoGridCellTemplate let-movimentacao>
      <div class="movimentacao-identificador">#{{movimentacao.id}}</div>
      <div class="movimentacao-etiquetas">
        <span class="badge"
              [ngClass]="{'badge-danger': movimentacao.quantidade < 0,
                          'badge-success': movimentacao.quantidade > 0,
                          'badge-secondary': movimentacao.quantidade === 0}">
          {{movimentacao.tipo}}
        </span>
        <span class="badge"
              [ngClass]="{'badge-warning': movimentacao.reservada,
                          'badge-success': movimentacao.confirmada,
                          'badge-danger': movimentacao.cancelada}">
          {{movimentacao.status}}
        </span>
      </div>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column title="Insumo" [width]="230" *ngIf="exibirInsumo">
    <ng-template kendoGridCellTemplate let-movimentacao>
      <small class="d-block text-muted" *ngIf="movimentacao.insumo?.codigo">
        Código {{movimentacao.insumo.codigo}}
      </small>
      <strong class="insumo-nome">
        {{movimentacao.insumo?.nome || '—'}}
      </strong>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column title="Quantidade" [width]="135">
    <ng-template kendoGridCellTemplate let-movimentacao>
      <strong class="quantidade-movimentada"
              [ngClass]="{'text-danger': movimentacao.quantidade < 0,
                          'text-success': movimentacao.quantidade > 0}">
        {{movimentacao.quantidade}} {{obtenhaDescricaoUnidade(movimentacao)}}
      </strong>
      <small class="d-block mt-1 text-muted">
        <i class="k-icon mr-1"
           [ngClass]="{'k-i-check-circle text-success': movimentacao.retornarEstoque,
                       'k-i-times-circle text-danger': !movimentacao.retornarEstoque}"></i>
        {{movimentacao.retornarEstoque ? 'Retornável' : 'Não retornável'}}
      </small>
      <small class="d-block mt-2 apresentacao-movimentacao" *ngIf="movimentacao.descricaoApresentacao">
        <i class="fas fa-box-open mr-1"></i>
        {{movimentacao.quantidadeApresentacao}} × {{movimentacao.descricaoApresentacao}}
        <span class="d-block text-muted">Fator aplicado: {{movimentacao.fatorConversaoAplicado}}</span>
      </small>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column title="Origem" [width]="185">
    <ng-template kendoGridCellTemplate let-movimentacao>
      <ng-container *ngIf="movimentacao.pedido">
        <small class="d-block text-muted">Pedido</small>
        <a [routerLink]="'/admin/pedidos/detalhes/' + movimentacao.pedido.guid">
          <strong>{{movimentacao.pedido.codigo}}</strong>
        </a>
      </ng-container>

      <ng-container *ngIf="movimentacao.operador">
        <small class="d-block text-muted" [class.mt-2]="movimentacao.pedido">Operador</small>
        <strong>{{movimentacao.operador.nome}}</strong>
      </ng-container>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column title="Datas" [width]="190">
    <ng-template kendoGridCellTemplate let-movimentacao>
      <small class="d-block text-muted">Movimentação</small>
      <span class="data-movimentacao">
        {{movimentacao.horario | date: "dd/MM/yyyy HH:mm:ss"}}
      </span>

      <small class="d-block mt-2 text-muted">Processamento</small>
      <span class="data-movimentacao" *ngIf="possuiFotografiaFinanceira(movimentacao)">
        {{movimentacao.processadoEm | date: "dd/MM/yyyy HH:mm:ss"}}
      </span>
      <span class="text-warning" *ngIf="!possuiFotografiaFinanceira(movimentacao) && movimentacao.reservada">
        Aguardando confirmação
      </span>
      <span class="text-muted" *ngIf="!possuiFotografiaFinanceira(movimentacao) && movimentacao.cancelada">
        Sem processamento
      </span>
      <span *ngIf="!possuiFotografiaFinanceira(movimentacao) && !movimentacao.reservada && !movimentacao.cancelada">
        —
      </span>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column title="Financeiro" [width]="245" *ngIf="exibeDadosFinanceiros">
    <ng-template kendoGridCellTemplate let-movimentacao>
      <ng-container *ngIf="possuiFotografiaFinanceira(movimentacao)">
        <div class="financeiro-valores">
          <div>
            <small class="d-block text-muted">Unitário</small>
            <strong>{{movimentacao.custoUnitario | currency:'BRL'}}</strong>
          </div>
          <div>
            <small class="d-block text-muted">Total</small>
            <strong>{{movimentacao.custoTotal | currency:'BRL'}}</strong>
          </div>
        </div>
        <small class="d-block mt-2 text-muted">
          Média: {{movimentacao.custoMedioAnterior == null ? '—' : (movimentacao.custoMedioAnterior | currency:'BRL')}}
          → {{movimentacao.custoMedioResultante | currency:'BRL'}}
        </small>
        <small class="d-block mt-1 text-muted">
          Saldo: {{movimentacao.saldoQuantidadeResultante}} {{obtenhaDescricaoUnidade(movimentacao)}}
          · {{movimentacao.valorResultante | currency:'BRL'}}
        </small>
      </ng-container>

      <span class="text-warning" *ngIf="!possuiFotografiaFinanceira(movimentacao) && movimentacao.reservada">
        Aguardando confirmação
      </span>
      <span class="text-muted" *ngIf="!possuiFotografiaFinanceira(movimentacao) && movimentacao.cancelada">
        Sem efeito financeiro
      </span>
      <span *ngIf="!possuiFotografiaFinanceira(movimentacao) && !movimentacao.reservada && !movimentacao.cancelada">
        —
      </span>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column title="Detalhes" [width]="280">
    <ng-template kendoGridCellTemplate let-movimentacao>
      <ng-container *ngIf="movimentacao.motivoDaMovimentacao || movimentacao.observacao ||
                           movimentacao.justificativa || movimentacao.movimentacaoEstornada?.id ||
                           movimentacao.beneficiamento?.id; else semDetalhes">
        <strong class="d-block" *ngIf="movimentacao.motivoDaMovimentacao">
          {{movimentacao.motivoDaMovimentacao.descricao}}
        </strong>
        <span class="observacao-limitada text-muted"
              *ngIf="movimentacao.observacao"
              kendoTooltip
              [title]="movimentacao.observacao">
          {{movimentacao.observacao}}
        </span>
        <small class="d-block mt-1" *ngIf="movimentacao.justificativa">
          <b>Justificativa:</b> {{movimentacao.justificativa}}
        </small>
        <small class="d-block mt-1 text-muted" *ngIf="movimentacao.movimentacaoEstornada?.id">
          Estorno de #{{movimentacao.movimentacaoEstornada.id}}
        </small>
        <button type="button" class="btn btn-link btn-sm lote-beneficiamento-link"
                *ngIf="movimentacao.beneficiamento?.id"
                (click)="abraBeneficiamento(movimentacao.beneficiamento)"
                [disabled]="carregandoBeneficiamento">
          <i class="fas fa-industry mr-1"></i>
          Lote de beneficiamento #{{movimentacao.beneficiamento.id}}
        </button>
      </ng-container>
      <ng-template #semDetalhes>—</ng-template>
    </ng-template>
  </kendo-grid-column>
</kendo-grid>

<div class="alert alert-danger mt-3" *ngIf="erroBeneficiamento && !detalheBeneficiamento">
  {{erroBeneficiamento}}
</div>

<kendo-dialog *ngIf="detalheBeneficiamento" (close)="fecheBeneficiamento()"
              [minWidth]="320" [width]="850">
  <kendo-dialog-titlebar>
    Lote de beneficiamento #{{detalheBeneficiamento.id}}
  </kendo-dialog-titlebar>

  <div class="beneficiamento-cabecalho">
    <div>
      <small>Ficha técnica</small>
      <strong>{{detalheBeneficiamento.fichaTecnica?.nome}}</strong>
    </div>
    <div>
      <small>Status</small>
      <span class="badge"
            [ngClass]="detalheBeneficiamento.status === 'CONFIRMADO' ? 'badge-success' : 'badge-secondary'">
        {{detalheBeneficiamento.status}}
      </span>
    </div>
    <div>
      <small>Operador</small>
      <strong>{{detalheBeneficiamento.operador?.nome}}</strong>
    </div>
    <div>
      <small>Data</small>
      <strong>{{detalheBeneficiamento.horario | date:'dd/MM/yyyy HH:mm:ss'}}</strong>
    </div>
  </div>

  <div class="beneficiamento-rendimento">
    <div><small>Receitas preparadas</small><strong>{{detalheBeneficiamento.quantidadeReceitas | number:'1.0-6'}}</strong></div>
    <div><small>Rendimento padrão</small><strong>{{detalheBeneficiamento.rendimentoPadraoAplicado | number:'1.0-3'}} {{detalheBeneficiamento.unidadeMedida?.sigla}}</strong></div>
    <div><small>Rendimento esperado</small><strong>{{detalheBeneficiamento.quantidadeEsperada | number:'1.0-3'}} {{detalheBeneficiamento.unidadeMedida?.sigla}}</strong></div>
    <div><small>Produção real</small><strong>{{detalheBeneficiamento.quantidadeProduzida | number:'1.0-3'}} {{detalheBeneficiamento.unidadeMedida?.sigla}}</strong></div>
    <div [ngClass]="classeVariacaoBeneficiamento(detalheBeneficiamento)">
      <small>Variação</small>
      <strong>{{detalheBeneficiamento.variacaoQuantidade > 0 ? '+' : ''}}{{detalheBeneficiamento.variacaoQuantidade | number:'1.0-3'}}
        {{detalheBeneficiamento.unidadeMedida?.sigla}}
        ({{detalheBeneficiamento.variacaoPercentual > 0 ? '+' : ''}}{{detalheBeneficiamento.variacaoPercentual | number:'1.0-2'}}%)</strong>
    </div>
  </div>

  <div class="table-responsive mt-3">
    <table class="table table-sm table-striped">
      <thead><tr><th>Ingrediente consumido</th><th>Quantidade</th><th *ngIf="detalheBeneficiamento.custoTotal != null">Custo</th></tr></thead>
      <tbody>
      <tr *ngFor="let ingrediente of detalheBeneficiamento.ingredientes">
        <td>{{ingrediente.insumo?.nome}}</td>
        <td>{{ingrediente.quantidadeConsumida | number:'1.0-3'}} {{ingrediente.unidade?.sigla}}</td>
        <td *ngIf="detalheBeneficiamento.custoTotal != null">{{ingrediente.custoTotal | currency:'BRL'}}</td>
      </tr>
      </tbody>
    </table>
  </div>

  <div class="beneficiamento-custos" *ngIf="detalheBeneficiamento.custoTotal != null">
    <span>Custo total transferido: <strong>{{detalheBeneficiamento.custoTotal | currency:'BRL'}}</strong></span>
    <span>Custo por {{detalheBeneficiamento.unidadeMedida?.sigla}}:
      <strong>{{detalheBeneficiamento.custoUnitario | currency:'BRL'}}</strong></span>
  </div>

  <p class="mt-3 mb-0" *ngIf="detalheBeneficiamento.observacao">
    <strong>Observação:</strong> {{detalheBeneficiamento.observacao}}
  </p>
  <div class="alert alert-secondary mt-3 mb-0" *ngIf="detalheBeneficiamento.status === 'ESTORNADO'">
    <strong>Lote estornado</strong>
    <span *ngIf="detalheBeneficiamento.estornadoPor"> por {{detalheBeneficiamento.estornadoPor.nome}}</span>
    em {{detalheBeneficiamento.estornadoEm | date:'dd/MM/yyyy HH:mm:ss'}}.
    <span class="d-block" *ngIf="detalheBeneficiamento.justificativaEstorno">
      Justificativa: {{detalheBeneficiamento.justificativaEstorno}}
    </span>
  </div>

  <div class="form-group mt-3" *ngIf="confirmandoEstornoBeneficiamento">
    <label>Justificativa do estorno</label>
    <textarea class="form-control" maxlength="500" rows="3"
              [(ngModel)]="justificativaEstornoBeneficiamento"
              placeholder="Explique por que todo o lote será estornado"></textarea>
  </div>
  <div class="alert alert-danger mt-3 mb-0" *ngIf="erroBeneficiamento">{{erroBeneficiamento}}</div>

  <kendo-dialog-actions>
    <button kendoButton (click)="fecheBeneficiamento()" [disabled]="estornandoBeneficiamento">Fechar</button>
    <button kendoButton *ngIf="detalheBeneficiamento.podeEstornar && !confirmandoEstornoBeneficiamento"
            (click)="prepareEstornoBeneficiamento()" [disabled]="estornandoBeneficiamento">
      Estornar lote
    </button>
    <button kendoButton *ngIf="confirmandoEstornoBeneficiamento"
            (click)="canceleEstornoBeneficiamento()" [disabled]="estornandoBeneficiamento">
      Voltar
    </button>
    <button kendoButton [primary]="true" *ngIf="confirmandoEstornoBeneficiamento"
            (click)="estorneBeneficiamento()" [disabled]="estornandoBeneficiamento">
      <i *ngIf="estornandoBeneficiamento" class="k-icon k-i-loading mr-1"></i>Confirmar estorno integral
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
